export default "__VITE_ASSET__D5xIl8S8__"